<!--
 * @Author: awu
 * @Date: 2020-12-08 22:11:19
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 22:15:57
 * @Description: file content
-->
<template>
  <div class="shade">123</div>
</template>

<script>
export default {
    name:"Shade"
}
</script>

<style lang="scss" scoped>
    .shade{
        width: 100vw;
        height: 100vh;
        background-color: red;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
</style>


// WEBPACK FOOTER //
// src/components/shade/index.vue